import React from 'react';
import * as s from './styles.scss';

export interface VisibilityWrapperProps {
  name: string;
  visible?: boolean;
  display?: boolean;
}

interface DivWrapperProps {
  className?: string;
  'aria-hidden'?: boolean;
  'aria-disabled'?: boolean;
  tabIndex?: number;
  'data-hook': string;
}

export const VisibilityWrapper: React.FunctionComponent<VisibilityWrapperProps> =
  (props) => {
    const { visible = true, display = true, children, name } = props;
    const divWrapperProps: DivWrapperProps = {
      'data-hook': `wcn-visibility-wrapper${name ? `-${name}` : ''}`,
    };

    if (!visible) {
      divWrapperProps.className = s.hide;
      divWrapperProps['aria-hidden'] = true;
      divWrapperProps['aria-disabled'] = true;
      divWrapperProps.tabIndex = -1;
    }

    return (
      <div {...divWrapperProps} hidden={!visible ? true : null}>
        {display ? children : null}
      </div>
    );
  };
VisibilityWrapper.displayName = 'VisibilityWrapper';
